<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <template v-if="!mandat.ID && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Mandat inexistant</b-alert>
        </b-col>
      </b-row>
    </template>

    <b-row class="mx-1" v-if="loaded">
      <b-col lg="6">
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6"> Créer un arrangement </b-card-title>
          <b-row>
            <b-col lg="4">
              <label>Date du mandat</label>
              <b-datepicker
                locale="fr-BE"
                readonly
                v-model="mandat.date_ouverture.value"
              ></b-datepicker>
            </b-col>
            <b-col lg="3">
              <label>Solde total</label>
              <b-input-group append="€">
                <b-input
                  v-model="mandat.solde"
                  class="text-right"
                  readonly
                ></b-input>
              </b-input-group>
            </b-col>
            <b-col lg="3">
              <label>Solde principal</label>
              <b-input-group append="€">
                <b-input
                  v-model="mandat.principal"
                  class="text-right"
                  readonly
                ></b-input>
              </b-input-group>
            </b-col>
            <b-col lg="2">
              <label>Age du débiteur</label>
              <b-input-group append="ans">
                <b-input
                  :value="ageDebiteur()"
                  class="text-right"
                  readonly
                ></b-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row v-if="!isComplete()">
            <b-col>
              <b-card class="mt-4">
                <b-checkbox
                  @input="handleTypeCalcul"
                  class="mb-3"
                  v-model="interets"
                  >Ajouter les intérêts de retard ({{
                    mandat.interet_taux.value
                  }}% par an)</b-checkbox
                >
                <b-tabs content-class="mt-3">
                  <b-tab title="Paiement fixe">
                    <b-row>
                      <b-col lg="3">
                        <label>Montant</label>
                        <b-input-group append="€">
                          <b-input
                            v-model="fixed.amount"
                            class="text-right"
                            @keyup.native.enter="addFixe"
                          ></b-input>
                        </b-input-group>
                        <b-toast
                          id="too-small"
                          title="Recuperator"
                          no-auto-hide
                          toaster="b-toaster-top-right"
                          variant="danger"
                        >
                          Le montant est trop bas. Minimum 20 €
                        </b-toast>
                      </b-col>
                      <b-col lg="6">
                        <label>Date</label>
                        <b-datepicker
                          locale="fr-BE"
                          required
                          v-model="fixed.date"
                        ></b-datepicker>
                        <b-toast
                          id="too-early"
                          title="Recuperator"
                          no-auto-hide
                          toaster="b-toaster-top-right"
                          variant="danger"
                        >
                          La date de paiement ne peut pas être dans le passé
                        </b-toast>
                      </b-col>
                      <b-col lg="1" offset-lg="2" class="align-self-end">
                        <b-button variant="success" @click="addFixe"
                          ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                        ></b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab
                    title="Paiement périodique"
                    @click="handleTypeCalcul"
                    active
                  >
                    <b-row>
                      <b-col lg="3">
                        <label>Périodicité</label>
                        <b-select
                          v-model="periodic.periodicity"
                          :options="periods"
                          @change="handleTypeCalcul"
                        ></b-select>
                      </b-col>
                      <b-col lg="3">
                        <label>Type de calcul</label>
                        <b-select
                          v-model="periodic.type_calcul"
                          :options="typesCalcul"
                          @change="handleTypeCalcul"
                        ></b-select>
                      </b-col>
                      <b-col lg="3" v-if="periodic.type_calcul == 'total'">
                        <label>Montant</label>
                        <b-input-group append="€">
                          <b-input
                            v-model="periodic.amount"
                            class="text-right"
                            @keyup.native.enter="addPeriodic"
                          ></b-input>
                        </b-input-group>
                      </b-col>
                      <b-col
                        lg="2"
                        v-if="periodic.type_calcul == 'nombre_paiements'"
                      >
                        <label>Paiements</label>
                        <b-input-group append="fois">
                          <b-input
                            type="number"
                            min="1"
                            v-model="periodic.duree"
                            class="text-center"
                            @input="handleTypeCalcul"
                            @keyup.native.enter="addPeriodic"
                          ></b-input>
                        </b-input-group>
                      </b-col>
                      <b-col
                        lg="3"
                        v-if="periodic.type_calcul == 'nombre_paiements'"
                      >
                        <label>Montant</label>
                        <b-input-group>
                          <b-input
                            v-model="periodic.amount"
                            class="text-right"
                            @keyup.native.enter="addPeriodic"
                          ></b-input>
                          <b-input-group-append>
                            <b-input-group-text>€</b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col lg="1" class="align-self-end">
                        <b-button variant="success" @click="addPeriodic"
                          ><b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                        ></b-button>
                      </b-col>
                    </b-row>

                    <b-row class="mt-3">
                      <b-col lg="6">
                        <label>Date de début</label>
                        <b-datepicker
                          locale="fr-BE"
                          required
                          v-model="periodic.date_start"
                        ></b-datepicker>
                        <b-toast
                          id="too-early-periodic"
                          title="Recuperator"
                          no-auto-hide
                          toaster="b-toaster-top-right"
                          variant="danger"
                        >
                          La date de commencement d'un paiement périodique doit
                          se situer après le dernier paiement encodé et ne peut
                          pas se situer dans le passé
                        </b-toast>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="plan.length > 0" class="my-3 bg-light shadow">
          <b-card-title><h6>Résumé</h6></b-card-title>
          <b-table
            hover
            striped
            :items="resume"
            thead-class="hidden_header"
          ></b-table>

          <highcharts :options="charted" ref="chart"></highcharts>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card class="mb-3 bg-light shadow">
          <b-card-title><h6>Prévisualisation</h6></b-card-title>
          <b-button @click="reinitialize" class="mb-3" v-if="plan.length > 0"
            >Réinitialiser</b-button
          >
          <div class="plan-previsualisation">
            <b-table
              v-if="plan.length > 0"
              striped
              small
              hover
              :items="plan"
              :fields="fields"
            >
            </b-table>
            <b-alert v-else show variant="info">
              Ajouter des paiements à l'aide du panneau de gauche
            </b-alert>
          </div>
        </b-card>
        <b-card v-if="plan.length > 0" class="mb-3 bg-light shadow">
          <b-card-title><h6>Confirmation</h6></b-card-title>
          <b-row>
            <mh-input
              mhClass="col-6"
              field="initiative"
              :table="arrangement"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="communicationType"
              :table="arrangement"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="communicationDate"
              :table="arrangement"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="compte_societeID"
              :table="arrangement"
            ></mh-input>
            <b-col lg="12">
              <b-checkbox v-model="autoSMS">SMS automatique</b-checkbox>
              
            </b-col>
          </b-row>
          <b-button @click="confirmation" class="mt-4"
            >Confirmer l'arrangement</b-button
          >
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
import settlements from "@/services/settlements";
import DateTime from "@/services/DateTime.js";
import moment from "moment";
import MhInput from "@/components/MhInput.vue";
import { Chart } from "highcharts-vue";
export default {
  name: "newSettlement",
  components: {
    highcharts: Chart,
    MhInput,
  },
  props: {
    id: [String, Number],
    amount: [String, Number],
    date: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      arrangement: {},
      interets: true,
      sections: [],
      realSections: [],
      charted: null,
      plan: [],
      mandat: {},
      items: [],
      fields: [
        {
          key: "startDate",
          label: "Date",
          formatter: (value) => this.toDate(value),
        },
        {
          key: "montant",
          label: "Montant",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "principal",
          label: "Principal",
          class: "text-right",
          formatter: (value) => {
            if (value > 0) {
              return Number(value).toFixed(2) + " €";
            }
            return "";
          },
        },
        {
          key: "solde",
          label: "Solde",
          class: "text-right",
          formatter: (value) => {
            return Number(value).toFixed(2) + " €";
          },
        },
        {
          key: "interets",
          label: "Intérêts",
          class: "text-right",
          formatter: (value) => {
            if (value > 0) {
              return Number(value).toFixed(2) + " €";
            }
            return "";
          },
        },
      ],
      fixed: {
        amount: 20,
        date: new Date(),
      },
      periodic: {
        amount: 20,
        date_start: new Date(),
        date_end: null,
        duree: 10,
        periodicity: "mensuel",
        type_calcul: "total",
      },

      periods: [
        { value: "hebdomadaire", text: "hebdomadaire" },
        { value: "mensuel", text: "mensuel" },
      ],
      typesCalcul: [
        { value: "total", text: "Jusqu'au total" },
        { value: "nombre_paiements", text: "Nombre de paiements" },
      ],

      montantTotal: 0,
      interetsTotal: 0,
      dureePlan: 0,
      dernierPaiement: null,
      autoSMS: true
    };
  },
  created() {
    this.load();
    if (this.amount) {
      this.periodic.amount = this.amount;
    }
    if (this.date) {
      this.periodic.date_start = moment(this.date).toDate();
    }
  },
  computed: {
    resume() {
      let ret = [
        {
          label: "Total des paiements",
          value: Number(this.montantTotal).toFixed(2) + " €",
        },
        {
          label: "Total des intérêts",
          value: Number(this.interetsTotal).toFixed(2) + " €",
        },
        {
          label: "Durée du plan de remboursement",
          value: Number(this.dureePlan) + " mois",
        },
        {
          label: "Date du dernier paiement",
          value: this.toDate(this.dernierPaiement),
        },
      ];
      if ((this.mandat.debiteur.date_naissance.value !== "0000-00-00") && this.mandat.debiteur.date_naissance.value) {
        let d1 = moment(this.mandat.debiteur.date_naissance.value);
        let d2 = moment(this.dernierPaiement);
        let age = d2.diff(d1, "years");
        ret.push({
          label: "Âge du débiteur à la fin du plan",
          value: age + " ans",
        });
      }
      return ret;
    },
  },
  methods: {
    confirmation() {
      this.arrangement.totalPaiements.value = this.montantTotal;
      this.arrangement.totalInterets.value = this.interetsTotal;
      this.arrangement.dureePlan.value = this.dureePlan;
      this.arrangement.dateDernierPaiement.value =
        this.dernierPaiement.toISOString();
      settlements
        .post(
          JSON.stringify({
            mandatID: this.mandat.ID.value,
            dateEnd: this.dernierPaiement,
            principal: this.mandat.principal,
            solde: this.mandat.solde,
            arrangement: this.arrangement,
            sections: this.realSections,
            autoSMS: this.autoSMS
          })
        )
        .then((response) => {
          this.$router.push({
            name: "settlement",
            params: { id: response.data.ID },
          });
        });
    },
    reinitialize() {
      this.sections = [];
      this.plan = [];
      this.periodic.date_start = moment().toDate();
      this.fixed.date = moment().toDate();
      this.handleTypeCalcul();
    },
    ageDebiteur() {
      if ((this.mandat.debiteur.date_naissance.value !== "0000-00-00") && this.mandat.debiteur.date_naissance.value) {
        let d1 = moment(this.mandat.debiteur.date_naissance.value);
        let age = moment().diff(d1, "years");
        return age;
      }
      return "--";
    },
    sectionsPrev() {
      let ret = [];
      let currentPrincipal = this.mandat.principal;
      let currentSolde = Number(this.mandat.solde);
      let currentInterets = 0;
      let montantTotal = 0;
      let interetsTotal = 0;
      let startDate = moment();
      let currentMonth = 0;
      for (let i = 0; i < this.sections.length; i++) {
        if (this.sections[i].type == "fixe") {
          currentPrincipal -= this.sections[i].montant;
          if (currentPrincipal < 0) {
            currentPrincipal = 0;
          }
          if (this.interets) {
            let month = Math.round(
              moment(this.sections[i].startDate).diff(startDate, "month", true)
            );
            if (month != currentMonth) {
              currentMonth = month;
              currentInterets =
                currentPrincipal * (this.mandat.interet_taux.value / 1200);
              currentSolde = currentSolde + currentInterets;
            } else {
              currentInterets = 0;
            }
          }

          currentSolde -= this.sections[i].montant;
          currentSolde = Math.round(currentSolde * 100) / 100;
          if (currentSolde < 0) {
            currentSolde = 0;
          }
          montantTotal += Number(this.sections[i].montant);
          interetsTotal += Number(currentInterets);
          ret.push({
            startDate: this.sections[i].startDate,
            montant: this.sections[i].montant,
            principal: Number(currentPrincipal).toFixed(2),
            solde: Number(currentSolde).toFixed(2),
            interets: currentInterets ? Number(currentInterets).toFixed(2) : "",
          });
          this.dernierPaiement = this.sections[i].startDate;
        }
      }
      this.montantTotal = montantTotal;
      this.interetsTotal = interetsTotal;
      this.dureePlan = currentMonth;

      this.plan = ret;
      this.charted = {
        chart: {
          type: "area",
        },
        title: {
          text: "Évolution du solde, du principal et des paiements",
        },
        xAxis: {
          categories: this.plan.map((x) => this.toDate(x.startDate)),
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: "Euros (€)",
          },
        },
        tooltip: {
          split: true,
          pointFormat: "{series.name}: {point.y} €",
        },
        plotOptions: {
          area: {
            stacking: "normal",
            lineColor: "#666666",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#666666",
            },
          },
        },
        series: [
          {
            name: "Intérêts",
            data: this.plan.map((x) => +x.interets),
          },
          {
            name: "Principal",
            data: this.plan.map((x) => +x.principal),
          },
          {
            name: "Solde",
            data: this.plan.map((x) => +x.solde),
          },
        ],
      };
    },
    handleTypeCalcul() {
      if (this.periodic.type_calcul == "nombre_paiements") {
        let currentSolde = Number(this.mandat.solde);
        let currentPrincipal = Number(this.mandat.principal);
        let lastSection = this.getLastSection();
        if (lastSection) {
          currentSolde = Number(lastSection.solde);
          currentPrincipal = Number(lastSection.principal);
        }
        let duree = this.periodic.duree;
        if (this.interets) {
          this.periodic.amount = this.calculEcheanceInterets(
            currentPrincipal,
            currentSolde,
            duree
          );
        } else {
          let x = currentSolde / duree;
          this.periodic.amount = Math.ceil(x * 100) / 100;
        }
      }
    },
    calculEcheanceInterets(principal, total, n) {
      let montantZeroPourcent = total - principal;
      let interets = this.mandat.interet_taux.value / 1200;
      if (this.periodic.periodicity !== "mensuel") {
        interets = this.mandat.interet_taux.value / 2400;
      }
      if (interets == 0) {
        return Math.ceil((total / n) * 100) / 100;
      }
      let m = (principal * interets) / (1 - Math.pow(1 + interets, -n));
      let ajout = montantZeroPourcent / n;
      m = m + ajout;

      return Math.ceil(m * 100) / 100;
    },
    isComplete() {
      let last = this.getLastSection();
      if (parseFloat(last.solde) <= 0) {
        return true;
      }
      return false;
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    getLastDateSection() {
      if (this.plan.length == 0) {
        return new Date();
      }
      return this.plan[this.plan.length - 1].startDate;
    },
    getLastSection() {
      if (this.plan.length == 0) {
        return false;
      }
      return this.plan[this.plan.length - 1];
    },
    addPeriodic() {
      let lastDate = this.getLastDateSection();
      if (moment(this.periodic.date_start).isBefore(lastDate, "day")) {
        this.$bvToast.show("too-early-periodic");
        return false;
      }
      switch (this.periodic.type_calcul) {
        case "total":
          this.addPeriodicTotal();
          break;

        case "nombre_paiements":
          this.addPeriodicPaiements();
          break;
        default:
          return false;
      }
      this.sectionsPrev();
    },
    addPeriodicPaiements(instanciate = true) {
      let currentPrincipal = Number(this.mandat.principal);
      let currentSolde = Number(this.mandat.solde);
      let lastSection = this.getLastSection();
      if (lastSection) {
        currentPrincipal = Number(lastSection.principal);
        currentSolde = Number(lastSection.solde);
      }
      let duree = this.periodic.duree;
      let montant = Number(this.periodic.amount); //Number(currentSolde / duree).toFixed(2);
      let lastPaiement = 0;
      let currentDate;
      let startDate = moment();
      let currentMonth = 0;
      duree = 0;
      while (
        currentSolde > 0 &&
        duree < this.periodic.duree &&
        currentMonth < 360
      ) {
        let interval;
        if (this.periodic.periodicity == "mensuel") {
          interval = { n: duree, unity: "month" };
        } else {
          interval = { n: duree * 2, unity: "week" };
        }
        currentDate = moment(this.periodic.date_start).add(
          interval.n,
          interval.unity
        );
        currentPrincipal -= montant;
        if (currentPrincipal < 0) {
          currentPrincipal = 0;
        }
        if (this.interets && currentPrincipal) {
          let month = Math.round(
            moment(currentDate).diff(startDate, "month", true)
          );
          if (month != currentMonth) {
            currentMonth = month;
            let currentInterets =
              currentPrincipal * (this.mandat.interet_taux.value / 1200);

            currentSolde = currentSolde + currentInterets;
          }
        }
        currentSolde -= montant;
        currentSolde = Math.round(currentSolde * 100) / 100;
        if (currentSolde < 0) {
          lastPaiement = Math.round((currentSolde + montant) * 100) / 100;
          currentSolde = 0;
        }
        if (instanciate) {
          this.sections.push({
            startDate: currentDate.toDate(),
            type: "fixe",
            periodicite: null,
            duree: 1,
            montant: lastPaiement ? lastPaiement : montant,
            lastMontant: 0,
          });
        }
        duree++;
      }
      if (currentMonth == 360) {
        this.realSections.push({
          startDate: this.periodic.date_start,
          type: "periodique",
          periodicite: this.periodic.periodicity,
          duree: duree - 1,
          montant: montant,
          lastMontant: 0,
        });
      } else {
        this.realSections.push({
          startDate: this.periodic.date_start,
          type: "periodique",
          periodicite: this.periodic.periodicity,
          duree: duree - 1,
          montant: montant,
          lastMontant: lastPaiement ? lastPaiement : montant,
        });
      }

      this.fixed.date = moment(currentDate).add(1, "month").toDate();
      this.periodic.date_start = this.fixed.date;
    },

    addPeriodicTotal(instanciate = true) {
      let currentPrincipal = Number(this.mandat.principal);
      let currentSolde = Number(this.mandat.solde);
      let lastSection = this.getLastSection();
      this.periodic.amount = Number(this.periodic.amount);
      if (lastSection) {
        currentPrincipal = Number(lastSection.principal);
        currentSolde = Number(lastSection.solde);
      }
      let duree = 0;
      let lastPaiement = 0;
      let startDate = moment();
      let currentMonth = 0;
      let currentDate;
      while (currentSolde > 0 && currentMonth < 360) {
        let interval;
        if (this.periodic.periodicity == "mensuel") {
          interval = { n: duree, unity: "month" };
        } else {
          interval = { n: duree * 2, unity: "week" };
        }
        currentDate = moment(this.periodic.date_start).add(
          interval.n,
          interval.unity
        );
        currentPrincipal -= this.periodic.amount;
        if (currentPrincipal < 0) {
          currentPrincipal = 0;
        }
        if (this.interets && currentPrincipal) {
          let month = Math.round(
            moment(currentDate).diff(startDate, "month", true)
          );
          if (month != currentMonth) {
            currentMonth = month;
            let currentInterets =
              currentPrincipal * (this.mandat.interet_taux.value / 1200);
            currentSolde = currentSolde + currentInterets;
          }
        }
        currentSolde -= this.periodic.amount;
        currentSolde = Math.round(currentSolde * 100) / 100;
        if (currentSolde < 0) {
          lastPaiement =
            Math.round((currentSolde + this.periodic.amount) * 100) / 100;
          currentSolde = 0;
        }
        if (instanciate) {
          this.sections.push({
            startDate: currentDate.toDate(),
            type: "fixe",
            periodicite: null,
            duree: 1,
            montant: lastPaiement ? lastPaiement : this.periodic.amount,
            lastMontant: 0,
          });
        }
        duree++;
      }
      if (currentMonth == 360) {
        this.realSections.push({
          startDate: this.periodic.date_start,
          type: "periodique",
          periodicite: this.periodic.periodicity,
          duree: duree - 1,
          montant: this.periodic.amount,
          lastMontant: 0,
        });
      } else {
        this.realSections.push({
          startDate: this.periodic.date_start,
          type: "periodique",
          periodicite: this.periodic.periodicity,
          duree: duree - 1,
          montant: this.periodic.amount,
          lastMontant: lastPaiement ? lastPaiement : this.periodic.amount,
        });
      }

      this.fixed.date = currentDate.add(1, "month").toDate();
      this.periodic.date_start = this.fixed.date;
    },
    addFixe() {
      if (this.fixed.amount < 1) {
        this.$bvToast.show("too-small");
        return false;
      }
      if (moment(this.fixed.date).isBefore(moment(), "day")) {
        this.$bvToast.show("too-early");
        return false;
      }
      this.sections.push({
        startDate: moment(this.fixed.date),
        type: "fixe",
        periodicite: null,
        duree: 1,
        montant: this.fixed.amount,
        lastMontant: 0,
      });
      this.realSections.push({
        startDate: moment(this.fixed.date),
        type: "fixe",
        periodicite: null,
        duree: 1,
        montant: this.fixed.amount,
        lastMontant: 0,
      });
      this.fixed.date = moment(this.fixed.date).add(1, "month").toDate();
      this.periodic.date_start = this.fixed.date;
      this.sectionsPrev();
    },

    load() {
      warrants
        .get(this.id)
        .then((response) => {
          this.mandat = response.data;
          this.items = [
            {
              text: "Gestion",
              to: { name: "home" },
            },
            {
              text: "Mandats",
              to: { name: "warrants" },
            },
            {
              text:
                "Mandat n° " +
                this.mandat.ID.value +
                " (" +
                this.mandat.creancier.nom_soc.value +
                " vs " +
                this.mandat.debiteur.nom_complet.value +
                ")",
              to: {
                name: "warrantView",
                params: { id: this.mandat.ID.value },
              },
            },
            {
              text: "Nouvel arrangement",
              active: true,
            },
          ];
          this.mandat.solde = this.mandat.solde.toFixed(2);
          if (this.mandat.popUpAgenda.value == "0000-00-00") {
            this.mandat.popUpAgenda.value = null;
          }
          if (this.mandat.lastNegoDate.value == "0000-00-00") {
            this.mandat.lastNegoDate.value = null;
          }
          if (this.mandat.date_cloture.value == "0000-00-00") {
            this.mandat.date_cloture.value = null;
          }
          settlements.new(this.id).then((response) => {
            this.arrangement = response.data;
            if (!this.amount) {
              if (this.arrangement.last_amount.value) {
                this.periodic.amount = this.arrangement.last_amount.value;
              }
            }
            this.fixed.amount = this.mandat.solde;
          });
          this.loaded = true;
        })
        .catch((error) => {
          console.log(error);
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
<style>
.plan-previsualisation {
  max-height: 35vh;
  overflow-y: auto;
}
.hidden_header {
  display: none;
}
</style>